import initialState from '../states/favoritesData';

export default function (state = initialState, action) {
  switch (action.type) {
    case 'UP_DATE_FAVORITES_DATA':
      return { ...initialState, ...action.data }
    default: return state;
  }
}